import React from 'react';
import classnames from 'classnames';
import { IconSize } from '../../Icons/IconWrap';
import { isImageDeviation } from '../../DeviationViews/_helpers';
import Dumbo from '../../DeviationViews/Dumbo';
import s from './SystemNotificationIcon.scss';
// C96
export var SystemNotificationIcon = function (_a) {
    var IconComponent = _a.iconComponent, backgroundDeviation = _a.backgroundDeviation;
    var hasBackground = backgroundDeviation && isImageDeviation(backgroundDeviation);
    return (React.createElement("div", { className: classnames(s['root'], !hasBackground && s['empty-background']) },
        hasBackground && backgroundDeviation && (React.createElement(React.Fragment, null,
            React.createElement(Dumbo, { className: s['thumb'], deviation: backgroundDeviation, width: 50, height: 50 }),
            React.createElement("div", { className: s['overlay'] }))),
        React.createElement(IconComponent, { className: s['icon'], size: IconSize.MEDIUM, customSizable: true })));
};
SystemNotificationIcon.displayName = 'SystemNotificationIcon';
export default SystemNotificationIcon;
//# sourceMappingURL=SystemNotificationIcon.js.map